import Charges from '../Charges'
import { VehicleChargerChargesDashboardViewProps } from './index.types'

export default function VehicleChargerChargesDashboardView(
  props: VehicleChargerChargesDashboardViewProps,
) {
  return <Charges vehicle_charger_id={props.vehicleChargerId} />
}
